import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { applyRouteMeta } from '../../seo/metaTags';
import { getRouteMeta } from '../../seo/routeMeta';

const RouteMetaManager = () => {
  const location = useLocation();

  useEffect(() => {
    applyRouteMeta(getRouteMeta(location.pathname));
  }, [location.pathname]);

  return null;
};

export default RouteMetaManager;
